import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=bcdf51e6&"
import script from "./MaterialChartCard.vue?vue&type=script&lang=js&"
export * from "./MaterialChartCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&id=bcdf51e6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports